.status-col {
  display: flex;
  align-items: center;
  width: fit-content;

  .seem-icon {
    margin-right: var(--spacing-2);
    font-size: var(--font-size-s);
  }

  i.seem-icon-spinner {
    color: var(--text-color-soft);
  }
  i.seem-icon-double-refresh,
  i.seem-icon-spinner {
    color: var(--primary-theme-color);
  }

  i.seem-icon-error {
    color: var(--critical-alert-bg-color);
  }
}
